module.exports = __webpack_public_path__ + "static/media/door05.7f42c25b.png";